import Avatar from '../../../../../component/Avatar';
import { FlexCell, FlexRow, IconButton, Text, Tooltip } from '@epam/promo';
import ProjectStatus from './project-status';
import {
  ProjectShowroomStatus,
  ProjectStatus as EnumProjectStatus,
  ProjectRoles,
} from '../../../../../models/enums';
import { IProjectCard } from '../../../../project-list/components/project-card/modal';
import ProjectLinks from '../project-links';
import { ReactComponent as showroomIcon } from 'assets/svg/show-room.svg';
import projectListService from 'services/api/project-list/projectListService';
import { dateFormatter } from '../../../../../utils/dateUtils';
import { ProjectTags } from '../project-tags';
import { ProjectDescription } from '../project-description';
import OverflowTooltip from '../../../../../utils/OverflowTooltip';
import ProjectLinkedEvent from '../project-linked-event';
import { ProjectKeywords } from './project-keywords';

const STATUSES = [
  EnumProjectStatus.INITIAL,
  EnumProjectStatus.ACTIVE,
  EnumProjectStatus.CLOSED,
  EnumProjectStatus.SUSPENDED,
  EnumProjectStatus.DELETE,
];

function ProjectDetailsLeftInfo({
  project,
  userHasEditPermission,
  projectHasActiveShowroomRequest,
  onCloseParent,
  canBeMarkedForDeletion,
  projectApprovalRequired,
  userRoleInProject,
  isUserEventOrganizerForCurrentProject,
}: {
  project: IProjectCard;
  userHasEditPermission: boolean;
  projectHasActiveShowroomRequest: boolean;
  onCloseParent: () => void;
  canBeMarkedForDeletion: boolean;
  projectApprovalRequired?: boolean;
  userRoleInProject?: ProjectRoles;
  isUserEventOrganizerForCurrentProject: boolean;
}) {
  const {
    previewURL,
    info,
    status: projectStatus,
    showroom: statusShowroom,
    time,
    projectLinks,
    challenge,
    industries,
  } = project;

  const usefulLinks = [
    { id: -1, link: info.labUrl, linkType: 'GIT_REPO' },
    ...projectLinks,
  ];

  return (
    <>
      <div className="project-detail-left__info">
        <Avatar
          img={projectListService.getProfileProjectPicture(previewURL)}
          alt="Project Cover"
          cx="project-detail-left__info__image"
          size={'144'}
          initials={info.name.charAt(0)}
        />
        <div className="project-detail-left__info__body">
          <FlexRow>
            <OverflowTooltip
              text={info.name}
              cx="project-detail__name"
              font="museo-sans"
            />
          </FlexRow>
          <div>
            <FlexRow cx="project-detail-statuses-container">
              <ProjectStatus
                projectStatus={projectStatus}
                options={STATUSES}
                id={info.id}
                userHasEditPermissions={userHasEditPermission}
                isProjectHasActiveShowroomRequest={
                  projectHasActiveShowroomRequest
                }
                closeParentModal={onCloseParent}
                canBeMarkedForDeletion={canBeMarkedForDeletion}
                projectApprovalRequired={projectApprovalRequired}
                userRoleInProject={userRoleInProject}
                isUserEventOrganizerForCurrentProject={
                  isUserEventOrganizerForCurrentProject
                }
              />
              {statusShowroom.status == ProjectShowroomStatus.IN_SHOWROOM && (
                <Tooltip
                  content={`In Showroom since ${dateFormatter(
                    statusShowroom?.lastDateUpdateShowroomStatus
                  )}`}
                >
                  <FlexRow cx="project-detail-showroom-icon-container">
                    <IconButton icon={showroomIcon} color="amber" />
                    <Text
                      cx="project-detail-showroom-text"
                      lineHeight="18"
                      font="sans"
                      fontSize="14"
                    >
                      in Showroom
                    </Text>
                  </FlexRow>
                </Tooltip>
              )}
            </FlexRow>
            <FlexCell width="auto" cx="project-time">
              <FlexRow cx="project-time__item">
                <Text cx="project-time__title time-text">Last update:</Text>

                <Text cx="project-time__value time-text">
                  {dateFormatter(time.lastUpdate)}
                </Text>
              </FlexRow>
              <FlexRow cx="project-time__item">
                <Text cx="project-time__title time-text">Duration:</Text>

                <Text cx="project-time__value time-text">
                  {`${dateFormatter(time.plannedStartDate)} - ${dateFormatter(
                    time.plannedEndDate
                  )}`}
                </Text>
              </FlexRow>
            </FlexCell>
          </div>
        </div>
      </div>
      {((industries && industries.length > 0) ||
        info.technologies.length > 0) && (
        <ProjectTags industries={industries} technologies={info.technologies} />
      )}
      {info.description && info.description.length > 0 && (
        <ProjectDescription description={info.description} />
      )}
      <div className="divider" />
      {info.keywords && info.keywords.length > 0 && (
        <ProjectKeywords keywords={info.keywords} />
      )}
      {usefulLinks.length > 0 && <ProjectLinks links={usefulLinks} />}
      {!!challenge && (
        <ProjectLinkedEvent
          challengeId={challenge.challengeId}
          challengeLink={challenge.challengeLink}
          challengeName={challenge.challengeName}
        />
      )}
    </>
  );
}

export default ProjectDetailsLeftInfo;
